// extracted by mini-css-extract-plugin
module.exports = {"container":"TrayTab_container__8Wvo0","label":"TrayTab_label__3OiK5"};